/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {Icons as ɵa} from './feather/icons.provider';